export const version = '1.70.7';
export const buildTime = '2025-09-11 11:10:07 AM';
